import { render, staticRenderFns } from "./AnnouncementPopup.vue?vue&type=template&id=02477d9a&scoped=true&"
import script from "./AnnouncementPopup.vue?vue&type=script&lang=js&"
export * from "./AnnouncementPopup.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementPopup.vue?vue&type=style&index=0&id=02477d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02477d9a",
  null
  
)

export default component.exports